export enum ConfigPage {
    HOME = 'home',
    API_TOKENS = 'token',
    COEFFICIENT = 'coef',
    ACTIVITY_HISTORY = 'history',
    SETTINGS = 'settings',
}
